"use client";

import React from "react";

import { Eye, X } from "lucide-react";
import { UploadDocument } from "../Icons";

interface FilePreviewCardProps {
	file: File;
	onPreview: (url: string) => void;
	onRemove: () => void;
}

const FilePreviewCard: React.FC<FilePreviewCardProps> = ({
	file,
	onPreview,
	onRemove,
}) => {
	const fileURL = URL.createObjectURL(file);

	return (
		<div className="mt-4">
			<div className="p-3 bg-green-50 border border-green-200 rounded-md flex items-center justify-between">
				<div className="flex items-center">
					<div className="bg-green-100 p-2 rounded-md mr-3">
						<UploadDocument />
					</div>
					<div>
						<p className="text-sm font-medium">{file.name}</p>
						<p className="text-xs">{(file.size / 1024 / 1024).toFixed(2)} MB</p>
					</div>
				</div>
				<div className="flex items-center gap-2">
					<button
						onClick={() => onPreview(fileURL)}
						className="hover:text-blue-500 cursor-pointer">
						<Eye size={18} />
					</button>
					<button
						onClick={onRemove}
						className="hover:text-red-500 cursor-pointer">
						<X size={18} />
					</button>
				</div>
			</div>
		</div>
	);
};

export default FilePreviewCard;
